export default __webpack_public_path__ + "static/indoor2-e4c8fbe2aaafc69903258e606f411708.webp";